module.exports = __webpack_public_path__ + "img/amex.be4c2cec.svg";